import { gql } from '@apollo/client'

const PRIORITY_TASK_FRAGMENT = gql`
  fragment PriorityTaskFragment on PriorityTask {
    id
    name
    description
    createdAt
    createdBy {
      name
    }
    tags
    kpi
    allocationType
    priority
    isDone
    customRequiredDishCount
  }
`

export default PRIORITY_TASK_FRAGMENT
